
export default () => ({
  isLoading: false,
  serviceLoaded: false,
  fromRender: {
    date: null
  },
  insurances: {
    isLoading: false,
    hasError: false,
    searchId: null,
    current: {
      slug: null,
      name: null,
      price: {
        amount: 0,
        markup: 0,
        currency: 'RUB'
      }
    },
    collection: [],
    errors: []
  },
  form: {
    countryId: null,
    startDate: null,
    endDate: null,
    isActive: 0,
    ages: [],
    currency: 'RUB',
    isRepeatedSearch: 0
  },
  penalties: {
    isLoading: true,
    hasError: false,
    collection: [],
    errors: []
  },
})
